import React from "react";
import { Link } from "gatsby";

var Nav = function Nav() {
  return React.createElement("ul", null, React.createElement("li", null, React.createElement(Link, {
    to: "/contact/"
  }, "CONTATO")));
};

export default Nav;